// ===== SLICE INTERFACE =====

export interface UserSlice {
  user: {
    currentUser: string;
    setUser: (user: string) => void;
  };
}

// ===== SLICE CREATOR =====
// Phase 2: Full implementation with Immer v10

export const createUserSlice = (
  set: (fn: (state: UserSlice) => void) => void,
  _get: unknown,
  _store: unknown
) => ({
  user: {
    currentUser: 'System',

    setUser: (user: string) => {
      set((state) => {
        state.user.currentUser = user;
      });
    },
  },
});
